/**
 * Theme. Stored in `kv` under `setting:theme` so it is backed up and mirrored like any
 * other setting, rather than being a second, separate storage mechanism.
 *
 * 'system' is the default and means "follow the OS", which is what most people want.
 * The explicit values exist because a gym at 6am and a kitchen at midday are different
 * lighting problems and the OS setting is not always the right answer for both.
 */
export type Theme = 'system' | 'light' | 'dark';
export const THEMES: Theme[] = ['system', 'light', 'dark'];

export function isTheme(v: unknown): v is Theme {
  return v === 'system' || v === 'light' || v === 'dark';
}

/** Applies the theme, and keeps the iOS status-bar colour in step. */
export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  if (theme === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', theme);

  // Read the resolved background back out rather than hardcoding it twice.
  const bg = getComputedStyle(root).getPropertyValue('--bg').trim();
  let meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = 'theme-color';
    document.head.appendChild(meta);
  }
  if (bg) meta.content = bg;
}
